import React, { useState , useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import FilterDetail from "./FilterDetail";

export default function FilterMain( { show , setQ1 , setQ2 , procesado }) {
    const [visible, setVisible] = useState(false);

    function onProcesado(val)
    {

        

        setTimeout( ()  =>{
            procesado(val)
            setVisible( false )
        } , 250)


    }

    useEffect(() => {

        console.log( "setVisible ")

        setVisible( !visible )

    } , [show])


    return (
        <div className="card flex justify-content-center "  >
            {/* <Button label="Show" icon="pi pi-external-link" onClick={() => setVisible(true)} /> */}
            <Dialog header="Filtros" visible={visible} maximizable 
                style={{ width: '70%'  , height :'70vh' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                <FilterDetail setQ1={setQ1} setQ2={setQ2} show={show} procesado={(val)=> onProcesado(val)}></FilterDetail>
            </Dialog>
        </div>
    )
}